import { render, staticRenderFns } from "./ProductCardBig.vue?vue&type=template&id=7b1ef5b1"
import script from "./ProductCardBig.vue?vue&type=script&lang=js"
export * from "./ProductCardBig.vue?vue&type=script&lang=js"
import style0 from "./ProductCardBig.vue?vue&type=style&index=0&id=7b1ef5b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports